export const breadcrumbs = {
  root: {
    name: '/dashboard',
    displayName: 'breadcrumbs.home',
  },
  routes: [
  {
    name: 'Dashboard',
    displayName: 'menu.dashboard',
  },
  {
    name: 'PaymentOrder',
    displayName: 'menu.paymentOrder',
    children: [
      {
        name: 'PayOrderDetails',
        displayName: 'menu.paymentOrderDetails',
      },
      {
        name: 'PaymentOrderDownload',
        displayName: 'menu.paymentOrderDownload',
      }
    ],
  },
  {
    name: 'Recurring',
    displayName: 'menu.recurrings',
    children: [
      {
        name: 'RecurringsDetail',
        displayName: 'menu.recurringsDetails',
      },
      {
        name: 'RecurringDownload',
        displayName: 'menu.recurringsDownload',
      }
    ],
  },
  {
    name: 'Report',
    displayName: 'menu.report',
  },
  {
    name: 'AdvanceDownload',
    displayName: 'menu.report'
  },
  {
    name: 'UserManagement',
    displayName: 'menu.userManagement',
    children: [{
      name: 'NewUser',
      displayName: 'menu.NewUser'
    }]
  },
  {
    name: 'UserManagement',
    displayName: 'menu.userManagement',
    children: [{
      name: 'EditUser',
      displayName: 'editUser'
    }]
  },
   {
      name: 'VirtualAccount',
      displayName: 'menu.virtualAccount',
     children: [{
       name: 'VirtualAccountDetail',
       displayName: 't.transactions'
     }]
    },
  {
    name: 'AppManagement',
    displayName: 'menu.appManagement',
    disabled: true,
    children: [
      {
        name: 'NewApp',
        displayName: 'menu.NewApp'
      },
      {
        name: 'EditAppInfo',
        displayName: 'menu.configApp'
      },
      {
        name: 'ViewAppInfo',
        displayName: 'view'
      },
    ]
  },
  // settlement
  /* {
    name: 'Settlement',
    displayName: 'menu.Settlement',
    disabled: true,
    children: [
      {
        name: 'NewSettlement',
        displayName: 'basic.button.newSettlement'
      },
      {
        name: 'settlementDetails',
        displayName: 'menu.settlementDetails'
      },
    ]
  }, */
  {
    name: 'FinancialManagementHome',
    displayName: 'menu.FinancialManagement',
    // disabled: true,
    children: [
      {
        name: 'FinancialManagement',
        displayName: 'menu.withdrawals',
      },
      {
        name: 'BankAccounts',
        displayName: 'menu.bankAccounts',
      }
    ],
  },
  {
    name: 'MerchantKYC',
    displayName: 'menu.kyc',
  },
  {
    name: 'WayBillList',
    displayName: 'menu.wayBill',
    children: [
      {
        name: 'BatchUpload',
        displayName: 'menu.batchUpload',
      },
      {
        name: 'WayBillDetail',
        displayName: 'menu.paymentOrderDetail',
      },
      {
        name: 'Download',
        displayName: 'menu.download',
      },
      {
        name: 'DownloadLog',
        displayName: 'menu.downloadLog',
      }
    ],
  },
  {
    name: 'Profile',
    displayName: 'menu.profile',
  },
  {
    name: 'statistics',
    displayName: 'menu.statistics',
    disabled: true,
    children: [{
      name: 'charts',
      displayName: 'menu.charts',
    },
    {
      name: 'progress-bars',
      displayName: 'menu.progressBars',
    },
    ],
  },
  {
    name: 'tables',
    displayName: 'menu.tables',
  },
  {
    name: 'ui',
    displayName: 'menu.uiElements',
    disabled: true,
    children: [{
      name: 'typography',
      displayName: 'menu.typography',
    },
    {
      name: 'buttons',
      displayName: 'menu.buttons',
    },
    {
      name: 'collapse',
      displayName: 'menu.collapse',
    },
    {
      name: 'filters',
      displayName: 'menu.filters'
    },
    {
      name: 'color-pickers',
      displayName: 'menu.colorPickers',
    },
    {
      name: 'timelines',
      displayName: 'menu.timelines',
    },
    {
      name: 'notifications',
      displayName: 'menu.notifications',
    },
    {
      name: 'dropdowns',
      displayName: 'menu.dropdowns',
    },
    {
      name: 'icon-sets',
      displayName: 'menu.icons',
      children: [{
        displayName: 'concrete',
        name: 'icon-set',
      } ],
    },
    {
      name: 'spinners',
      displayName: 'menu.spinners',
    },
    {
      name: 'grid',
      displayName: 'menu.grid',
    },
    {
      name: 'modals',
      displayName: 'menu.modals',
    },
    {
      name: 'file-upload',
      displayName: 'menu.fileUpload',
    },
    {
      name: 'tags',
      displayName: 'menu.tags',
    },
    {
      name: 'cards',
      displayName: 'menu.cards',
    },
    {
      name: 'tree-view',
      displayName: 'menu.treeView',
    },
    ],
  },
  {
    name: 'extra',
    displayName: 'menu.extra',
  },
  {
    name: 'maps',
    displayName: 'menu.maps',
    disabled: true,
    children: [{
      name: 'google-maps',
      displayName: 'Google Maps',
    },
    {
      name: 'yandex-maps',
      displayName: 'Yandex Maps',
    },
    {
      name: 'leaflet-maps',
      displayName: 'Leaflet Maps',
    },
    {
      name: 'bubble-maps',
      displayName: 'Bubble Maps',
    },
    {
      name: 'line-maps',
      displayName: 'Line Maps',
    },
    ],
  },
  {
    name: 'pages',
    displayName: 'menu.pages',
    disabled: true,
    children: [{
      name: '404-pages',
      displayName: '404 Pages',
    } ],
  },
  ],
}
